import { useSnapshot } from 'valtio'
import { activeModalStack, hideCurrentModal } from '../globalState'
import { guiOptionsScheme, OptionsGroupType } from '../optionsGuiScheme'
import OptionsGroup from './OptionsGroup'
import { useIsModalActive } from './utilsApp'

export default () => {
  useIsModalActive('options-*')
  const { reactType } = useSnapshot(activeModalStack).at(-1) ?? {}
  if (!reactType?.startsWith('options-')) return
  const groupName = reactType.slice('options-'.length)
  if (!(groupName in guiOptionsScheme)) return
  const settingsGroup = groupName as OptionsGroupType

  return <OptionsGroup group={settingsGroup} backButtonAction={hideCurrentModal} />
}
